import { Selector } from '@ngxs/store';

import { FreeTag, News, NewsStatuses, NewsTag } from '../../models/news.model';
import { NewsAdminState, NewsAdminStateModel } from '../states/news-admin.state';

export class NewsAdminSelectors {
  @Selector([NewsAdminState])
  static news(state: NewsAdminStateModel): News[] {
    return state ? state.list : [];
  }

  @Selector([NewsAdminState])
  static activeNews(state: NewsAdminStateModel) {
    let filter = state.list;
    if (state.filters.type === 0) {
      filter = state.list.filter(news => news.isNews);
    } else if (state.filters.type === 1) {
      filter = state.list.filter(news => !news.isNews);
    }
    return filter;
  }

  @Selector([NewsAdminState])
  static getIsNews(state: NewsAdminStateModel) {
    let isNews = true;

    if (state.filters.type === 1) {
      isNews = false;
    }

    return isNews;
  }

  @Selector([NewsAdminState])
  static statusesFilter(state: NewsAdminStateModel): NewsStatuses[] {
    return state ? [{ code: '', caption: 'All', description: 'All' }, ...state.statuses] : [];
  }

  @Selector([NewsAdminState])
  static tagsNews(state: NewsAdminStateModel): NewsTag[] {
    let filter = state ? state.tags : [];
    if (state.filters.type === 0) {
      filter = state.tags.filter(news => news.isNews);
    } else if (state.filters.type === 1) {
      filter = state.tags.filter(news => !news.isNews);
    }
    return filter;
  }

  @Selector([NewsAdminState])
  static tagsFilterNews(state: NewsAdminStateModel): string[] {
    return state?.filters?.tags ? state?.filters.tags : [];
  }

  @Selector([NewsAdminState])
  static statuses(state: NewsAdminStateModel): NewsStatuses[] {
    return state ? state.statuses : [];
  }

  @Selector([NewsAdminState])
  static searchedText(state: NewsAdminStateModel): string | null {
    return state.filters.searchText;
  }

  @Selector([NewsAdminState])
  static selectedStatus(state: NewsAdminStateModel) {
    return state.filters.status;
  }

  @Selector([NewsAdminState])
  static selectedTags(state: NewsAdminStateModel) {
    return state.filters.tags;
  }

  @Selector([NewsAdminState])
  static selectedTab(state: NewsAdminStateModel) {
    return state.filters.type;
  }
}
